import { useAsync } from 'react-use'
import { useTranslation } from 'react-i18next'
import { Event } from '@nostr/tools/wasm'
import client from '@/services/client.service'
import { cn } from '@/lib/utils'
import { tagNameEquals } from '@/lib/tag'
import Emoji from '../Emoji'
import { parseReactionEmoji } from '../ReactionList'
import ContentPreview from '../ContentPreview'

export default function Reaction({ className, event }: { className?: string; event: Event }) {
  const { t } = useTranslation()
  const { value: targetEvent } = useAsync(async () => {
    const eTag = event.tags.find(tagNameEquals('e'))
    if (eTag?.[1]) {
      return client.fetchEvent({
        id: eTag[1],
        relays: eTag[2] ? [eTag[2]] : [],
        author: eTag[4]
      })
    }

    const aTag = event.tags.find(tagNameEquals('a'))
    if (aTag?.[1]) {
      const [kind, pubkey, ...identifier] = aTag[1].split(':')
      return client.fetchEvent({
        kind: Number(kind),
        pubkey,
        identifier: identifier.join(':'),
        relays: aTag[2] ? [aTag[2]] : []
      })
    }

    return undefined
  }, [event])

  return (
    <div className={cn('mt-2', className)}>
      <div className="flex items-center gap-1.5 text-sm text-muted-foreground mb-2">
        <Emoji emoji={parseReactionEmoji(event)} classNames={{ text: 'text-lg', img: 'size-4' }} />
        <span>{t('reacted')}</span>
      </div>
      {targetEvent && (
        <div className="border rounded-lg p-3 bg-muted/30">
          <ContentPreview event={targetEvent} />
        </div>
      )}
    </div>
  )
}
